<template>
  <report-details-page :report-code="REPORT_CODES.FIN_REZ" />
</template>

<script>
import ReportDetailsPage from '../ReportDetailsPage.vue'
import { REPORT_CODES } from '../utils/reportMetadata'

export default {
  name: 'create_document_report_fin_rez',
  components: {
    ReportDetailsPage
  },
  data() {
    return {
      REPORT_CODES
    }
  }
}
</script>
